var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00366211H513V341.989H0V-0.00366211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00366211H513V68.3927H0V-0.00366211ZM0 136.789H513V205.185H0V136.789ZM0 273.593H513V341.989H0V273.593Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 170.999L0 341.994V-0.00952148L256.5 170.999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6401 110.006L98.7766 156.595H147.766L108.135 185.39L123.271 231.98L83.6401 203.185L44.0079 231.98L59.1474 185.39L19.5161 156.595H68.5036L83.6401 110.006Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00756836)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/PR.0a0b4cf2e4c3d7dcf0b328c9e6d1cebb.svg";
export { ForwardRef as ReactComponent };